<template>
    <div class="row gx-3">
        <div class="col-12 justify-content-between align-items-center fitting-date mb-2">
            <b class="text-navy">Pick a date:</b>
            <Popper :content="errors?.app_date" arrow placement="top" class="w-100 m-0 border-0" :show="errors?.app_date ? true : false">
                <Field v-slot="{ value }" name="app_date" as="select" class="form-select flex-fill" v-model="selectedAppDate" @change="reloadFittingTimes()">
                    <option disabled selected value="">Select a day</option>
                    <option v-for="item, key in fitter.fitting_days" :key="item" :value="key">{{ item }}</option>
                </Field>
            </Popper>
        </div>
        <div class="col-12 justify-content-between align-items-center fitting-date mb-2" v-if="mobileFittingSlots[fitter.cal_account_number] || fitter.mobile == 0">
            <b class="text-navy">Pick a time:</b>
            <Popper :content="errors?.app_time" arrow placement="top" class="w-100 m-0 border-0" :show="errors?.app_time ? true : false">
                <Field name="app_time" as="select" class="form-select flex-fill" :disabled="selectedAppDate == ''" v-model="selectedAppTime" @change="updateFittingTime == true ? updateBasketFittingTime() : ''">
                    <option disabled value="">Select a time</option>
                    <option v-for="item, key in appTimes" :key="item" :value="key">{{ item }}</option>
                </Field>
            </Popper>
        </div>
    </div>
</template>

<script>
    import { Field } from 'vee-validate';
    import fitterDateTime from '@shared/mixins/fitterDateTime';
    
    export default {
        props: [
            'fitter',
            'mobileFittingSlots',
            'route',
            'customSlotCount',
            'updateFittingDate',
            'updateFittingTime',
            'selectedFittingDate',
            'selectedFittingTime',
            'selectedFittingEndTime',
            'fittingTimes',
            'errors'
        ],
        mixins: [fitterDateTime],
        components: {
            Field
        }
    }
</script>

<style lang="scss" scoped>

</style>